import React, { useEffect, useState, useRef, useMemo, memo } from "react";
import moment from "moment";
import ReactApexChart from "react-apexcharts";
import "./folders.css";


const useIsMounted = (logLabel) => {
  const isMounted = useRef(Math.floor(Math.random() * 10000 + 1));

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, [logLabel]);

  return isMounted;
};

const CircularProgressChart = memo(({ percentage, avatar, name, size = "large" }) => {
  const getColor = (percentage) => {
    if (percentage >= 80) return "#4CAF50"; // Green
    if (percentage >= 50) return "#FFC107"; // Yellow
    return "#F44336"; // Red
  };

  const chartSize = size === "small" ? 90 : 150;
  const fontSize = size === "small" ? "14px" : "20px";
  const hollowSize = size === "small" ? "45%" : "60%";

  const options = {
    chart: {
      type: "radialBar",
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: hollowSize,
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            show: false,
          },
        },
      },
    },
    fill: {
      colors: [getColor(percentage)],
    },
    stroke: {
      lineCap: "round",
    },
    labels: [`${name} `],
  };

  return (
    <div className={`radial-chart-container ${size}`}>
      <div className="chart-wrapper">
        <ReactApexChart
          options={options}
          series={[percentage]}
          type="radialBar"
          height={chartSize}
          width={chartSize}
          padding={0}
        />
        <div className="chart-percentagez" style={{ fontSize }}>
          {percentage}%
        </div>
      </div>
      {size === "large" && (
        <div className="chart-contentz">
          <img src={avatar} alt={name} className="chart-avatar" />
        </div>
      )}
    </div>
  );
});

const ComercielsFoldersAndDV = () => {
    const [sourcingData, setSourcingData] = useState(null);
    const [commercialData, setCommercialData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const isMountedRef = useIsMounted("blah");
    const [timer, setTimer] = useState(60);
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const sourcingUrl = "https://test.eurodistech.com/storage/json/sourcing.json";
          const commercialUrl = "https://test.eurodistech.com/storage/json/commercial-detail.json";
          const proxyBase = "https://corss-smoky.vercel.app/api/proxy?url=";


          const responses = await Promise.all([
            fetch(`${proxyBase}${encodeURIComponent(sourcingUrl)}`).then((res) => res.json()),
            fetch(`${proxyBase}${encodeURIComponent(commercialUrl)}`).then((res) => res.json()),
          ]);

  
          setSourcingData(responses[0]);
          setCommercialData(responses[1].sourcing);
          setLoading(false);
        } catch (error) {
          setError(error.message);
          setLoading(false);
        }
      };
  
      if (isMountedRef.current) {
        fetchData();
      }
    }, []);
  
    // Timer logic
    useEffect(() => {
      const interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer === 0) {
            clearInterval(interval);
            window.location.reload();
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
  
      return () => clearInterval(interval);
    }, []);
  
    if (loading) return <div className="loading">Loading...</div>;
    if (error) return <div className="error">Error: {error}</div>;
    if (!sourcingData) return <div className="no-data">No data available</div>;
  
    const currentDay = moment().format("dddd").toLowerCase();
  
    const renderBadge = (id, type) => {
      let badgeClass = "";
      if (type === "envoyer") badgeClass = "badge-envoyer";
      else if (type === "envoie") badgeClass = "badge-envoie";
      else if (type === "cloture") badgeClass = "badge-cloture";
  
      return <span key={id} className={`badge ${badgeClass}`}>{id}</span>;
    };

    const dvTotal = commercialData.reduce((sum, member) => {
        const dvCurrentDay = member[`dv_${currentDay}_str`] ? member[`dv_${currentDay}_str`].split(",").map(Number) : [];
        return sum + dvCurrentDay.length;
      }, 0);
      
      const dpTotal = commercialData.reduce((sum, member) => {
        const dpCurrentDay = member[`dp_${currentDay}_str`] ? member[`dp_${currentDay}_str`].split(",").map(Number) : [];
        return sum + dpCurrentDay.length;
      }, 0);
      
      const meriemtaux = dpTotal !== 0 ? (dvTotal / dpTotal) * 100 : 0;

      const getColor = (percentage) => {
        if (percentage >= 80) return "#4CAF50"; // Green
        if (percentage >= 50) return "#FFC107"; // Yellow
        return "#F44336"; // Red
    };

    const sortedCommercialData = [...commercialData].sort((a, b) => {
      const dvCountA = a[`dv_${currentDay}_str`] ? new Set(a[`dv_${currentDay}_str`].split(",").filter(Boolean)).size : 0;
      const dpCountA = a[`dp_${currentDay}_str`] ? new Set(a[`dp_${currentDay}_str`].split(",").filter(Boolean)).size : 1;
      const tauxA = (dvCountA * 100) / dpCountA;
      
      const dvCountB = b[`dv_${currentDay}_str`] ? new Set(b[`dv_${currentDay}_str`].split(",").filter(Boolean)).size : 0;
      const dpCountB = b[`dp_${currentDay}_str`] ? new Set(b[`dp_${currentDay}_str`].split(",").filter(Boolean)).size : 1;
      const tauxB = (dvCountB * 100) / dpCountB;
      
      return tauxB - tauxA; // Sort in descending order
      });
    
  
    return (
    <div>
      <div className="Apps">
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Taux</th>
                <th>DEVIS À ENVOYER</th>
                <th>DEVIS ENVOYER</th>
                <th>DOSSIER CLOTURE</th>
              </tr>
            </thead>
            <tbody>
              {sortedCommercialData.map((member) => {
                const dpTodayCloture = member.dp_today_cloture_str ? member.dp_today_cloture_str.split(",").map(Number) : [];
                const dpCurrentDay = member[`dp_${currentDay}_str`] ? member[`dp_${currentDay}_str`].split(",").map(Number) : [];
                const dvCurrentDay = member[`dv_${currentDay}_str`] 
                ? [...new Set(member[`dv_${currentDay}_str`].split(",").map(Number))] 
                : [];
  
                const taux = (dvCurrentDay.length / dpCurrentDay.length) * 100;

               
                  
                
  
                const dv_a_envoyer = dpCurrentDay.filter(item => !dvCurrentDay.includes(item));
                const dpcloture = dpTodayCloture.filter(item => ![...dpCurrentDay,...dvCurrentDay].includes(item));


                  

                
  
                return (
                  <tr key={member.id_user}>
                    <td width="25px" align="center"
                    style={{
                        background: `linear-gradient(to left, ${getColor(taux)}, white)`,
                        fontWeight: "bold",
                        color: "#000", // Ensuring text visibility
                        padding: "10px",
                        borderRadius: "5px", // Optional for better UI
                    }}>
                      <img
                        className="imgavatar"
                        style={{ width: 45, height: 45 }}
                        src={`https://www.eurodistech.com/erp/public/assets/images/avatars/${member.avatar}`}
                        alt={member.full_name}
                      />
                    </td>
                    <td
                        style={{
                            background: `linear-gradient(to right, ${getColor(taux)}, white)`,
                            fontWeight: "bold",
                            color: "#000", // Ensuring text visibility
                            padding: "10px",
                            borderRadius: "5px", // Optional for better UI
                        }}
                        >
                        {taux.toFixed(2)}%
                    </td>



                    <td>
                      {dv_a_envoyer.length > 0 ? (
                        <div style={{ display: "flex", flexDirection: "row", gap: 3, flexWrap: "wrap", paddingLeft: 5 }}>
                          {dv_a_envoyer.map((id) => renderBadge(id, "envoyer"))}
                        </div>
                      ) : (
                        "No devis to send"
                      )}
                    </td>
                    <td>
                      {dvCurrentDay.length > 0 ? (
                        <div style={{ display: "flex", flexDirection: "row", gap: 3, flexWrap: "wrap", paddingLeft: 5 }}>
                          {[...new Set(dvCurrentDay)].map((id) => renderBadge(id, "envoie"))}
                        </div>
                      ) : (
                        "No Folders for today"
                      )}
                    </td>
                    <td>
                      {dpcloture.length > 0 ? (
                        <div style={{ display: "flex", flexDirection: "row", gap: 3, flexWrap: "wrap", paddingLeft: 5 }}>
                          {dpcloture.map((id) => renderBadge(id, "cloture"))}
                        </div>
                      ) : (
                        "No closed Folders"
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
  
        {/* Circular Progress Chart for Meriem on the Right Side */}
        <div className="meriem-chart-wrapper">
            <CircularProgressChart
                percentage={meriemtaux.toFixed(2)}
                avatar="https://www.eurodistech.com/erp/public/assets/images/avatars/elhaouaf-hafid-29-thumb.jpg"
                name="hafid ELHOUAF"
                size="large"
            />
            <h2 className="meriem-percentage">{meriemtaux.toFixed(2)}%</h2>
        </div>&emsp;&emsp;&emsp;
      </div>
        {/* Timer */}
        <div className="timer">
        <p>
            Page will reload in <strong style={{ color: "red" }}>{timer}</strong> seconds...
        </p>
        </div>
    </div>
    );
  };
  

export default ComercielsFoldersAndDV;
